"use client";

import { useEffect, useRef } from "react";
import "leaflet/dist/leaflet.css";

// Leaflet attend [latitude, longitude]
const COORDS: [number, number] = [48.9884856, 2.2570332];

export default function OfficeMap({ label }: { label: string }) {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!container.current) return;

    let map: import("leaflet").Map | undefined;
    let cancelled = false;

    // Leaflet touche à window : chargé dynamiquement, donc jamais au rendu serveur
    void (async () => {
      const L = await import("leaflet");
      if (cancelled || !container.current) return;

      map = L.map(container.current, {
        center: COORDS,
        zoom: 16,
        // N'accapare pas le scroll de la page : zoom au double-clic ou aux boutons
        scrollWheelZoom: false,
      });

      // Tuiles OpenStreetMap : libres, sans clé ni compte.
      // Le rendu gris chaud est obtenu par un filtre CSS (cf. .leaflet-tile-pane)
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        detectRetina: true,
        maxZoom: 19,
      }).addTo(map);

      L.marker(COORDS, {
        title: "Valorhel Consulting",
        icon: L.divIcon({
          className: "office-pin",
          html: '<span class="office-marker"></span>',
          iconSize: [18, 18],
          iconAnchor: [9, 9],
          popupAnchor: [0, -12],
        }),
      })
        .addTo(map)
        .bindPopup(
          "<strong>Valorhel Consulting</strong><br />20 Rue de Stalingrad<br />95120 Ermont",
        );
    })();

    return () => {
      cancelled = true;
      map?.remove();
    };
  }, []);

  return (
    <div
      ref={container}
      role="region"
      aria-label={label}
      className="aspect-[16/10] w-full overflow-hidden rounded-2xl border border-ink/10 bg-paper"
    />
  );
}
